import React from "react"
//import { LanguageContext } from "../../context"
//import Icon from "../icon"
import SocialMediaItem from "./social-media-item"

 const SocialMediaList = (props) => {

   const { socialList } = props

   //const { t } = useContext(LanguageContext)
   return (
     <div className="unida-social-icons">
       <ul>
         {socialList?.map(media => {
           return (
             <SocialMediaItem
                key={media?.key}
                title={media?.title}
                icon={media?.icon}
                url={media?.url}
                className=""
                size={24}
                iconClassName={media?.iconClassName}
             />
           )
         })}
       </ul>
     </div>

   )
 }

 export default SocialMediaList
